import React, { createContext, useContext, useEffect, useMemo } from 'react';

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  useEffect(() => {
    if (typeof document === 'undefined') {
      return undefined;
    }

    document.documentElement.setAttribute('data-theme', 'light');
    return () => {
      document.documentElement.removeAttribute('data-theme');
    };
  }, []);

  const value = useMemo(
    () => ({
      mode: 'light',
      theme: 'light',
      setMode: () => {},
      cycleMode: () => {},
    }),
    []
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
